import React from 'react';
import { UserProductGroup } from '~/Api/User/ProductGroup';
import { selectCardinalPlural } from '~/utils/Intl';
import { Product } from '~/Product';
import Button from '~/UI/Button';
import primarySmallActionBarButtonStyles from '~/UI/Button/action-bar.less';
import Icon from '../Icon';

import iconButtonStyles from '~/UI/Button/icon.less';
import styles from './styles.less';

export interface Props {
	children?: React.ReactNode;
	selectedProductsCount: number;
	onClickRemoveRow(group: UserProductGroup, products: Product[]): void;
	onClickCancelDelete(): void;
	group: UserProductGroup;
	products: Product[];
}

export const ActionPanel: React.FunctionComponent<React.PropsWithChildren<Props>> = React.memo(
	({ children, selectedProductsCount, onClickRemoveRow, onClickCancelDelete, group, products }) => {
		return (
			<div className={styles.container}>
				<p className={styles.text}>
					<strong>{selectedProductsCount}</strong> selected{' '}
					{selectCardinalPlural(selectedProductsCount, ['item', 'items'])}{' '}
				</p>
				<Button
					data-testid='action-panel-delete-button'
					styles={primarySmallActionBarButtonStyles}
					onClick={() => onClickRemoveRow(group, products)}
				>
					Delete
				</Button>
				<p className={styles.text}>or copy to </p>
				{children || null}
				<div className={styles.closePanelButton}>
					<Button data-testid='action-panel-cancel-button' styles={iconButtonStyles} onClick={onClickCancelDelete}>
						<Icon name='close-white-simple' />
					</Button>
				</div>
			</div>
		);
	}
);

ActionPanel.displayName = 'Ui.ActionPanel.ActionPanel';
